import React, { Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import {
    Table, Pagination, PaginationItem, PaginationLink, Row, Col, Label, Card, Input, InputGroup, InputGroupAddon, InputGroupText,
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'rc-time-picker/assets/index.css';
import AuthModel from '../../../models/Auth';
import { connect } from 'react-redux';
import { faExternalLinkSquareAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { LIST_USER_CLIENTS, CLEAR_USER_CLIENTS, CLEAR_USER_PORTALS, CLEAR_PROGRAMS } from '../../../actions/clients';
import { SET_PROCESS_LIST } from '../../../actions/processList'
import ProcessListModel from '../../../models/ProcessList'
import { GET_PROGRAMS } from '../../../actions/programs';


const mapStateToProps = state => {
    return {
        processList: state.processList.allProcessList,
        userClients: state.clients.userClients,
        programs: state.programs.programs
    }
}

const mapActionsToProps = {
    SET_PROCESS_LIST: (list) => SET_PROCESS_LIST(list),
    LIST_USER_CLIENTS: (userId) => LIST_USER_CLIENTS(userId),
    GET_PROGRAMS: (filters) => GET_PROGRAMS(filters),
    CLEAR_USER_CLIENTS: () => CLEAR_USER_CLIENTS(),
    CLEAR_USER_PORTALS: () => CLEAR_USER_PORTALS(),
    CLEAR_PROGRAMS: () => CLEAR_PROGRAMS(),
}

class WarehouseLabel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            userClients: [],
            requestId: "",
            allProcessCountList: [],
            isCollectionDetails: false,
            isCPRequestLoading: false,
            isPrevActive: false,
            isNextActive: true,
            pageRange: 5,
            firstIndexOfBucket: 0,
            lastIndexOfBucket: 1,
            currentPage: 0,
            pagesCount: 1,
            itemsPerPage: 10,
        }
        this.clientIds = [];
    }

    async componentDidMount() {
        await this.props.CLEAR_USER_CLIENTS();
        await this.props.CLEAR_USER_PORTALS();
        await this.props.CLEAR_PROGRAMS();
        this.props.LIST_USER_CLIENTS(AuthModel.userId);
        const { userClients } = this.props;
        const clientIdList = userClients.map(item => item.clientId);
        this.clientIds = clientIdList;
        if (this.clientIds.length > 0) {
            await this.props.GET_PROGRAMS({
                where: {
                    clientId: { inq: this.clientIds }
                }
            });
            this.getProcessList();
        }
    }


    async UNSAFE_componentWillReceiveProps(nextProps) {
        const { userClients } = nextProps;
        if (JSON.stringify(userClients.sort()) !== JSON.stringify(this.props.userClients.sort())) {
            const clientIdList = userClients.map(item => item.clientId);
            this.clientIds = clientIdList;
            if (this.clientIds.length > 0) {
                await this.props.GET_PROGRAMS({
                    where: {
                        clientId: { inq: this.clientIds }
                    }
                });
            }
            this.setState({
                userClients
            });
            this.getProcessList();
        }
    }

    /*  get Processing Requests List */
    getProcessList = () => {
        this.setState({ isCPRequestLoading: true }, () => {
            const filters = this.buildGetProcessListFilters();
            if (filters.programs.length > 0) {
                ProcessListModel.getRequestDetailsCount(filters).then((requestDataCount) => {
                    if (JSON.stringify(requestDataCount) !== JSON.stringify(this.state.allProcessCountList)) {
                        this.setPagesCount(requestDataCount.count)
                    }                    
                    this.setState({ allProcessCountList: requestDataCount })
                    ProcessListModel.getRequestDetails(filters).then((requestData) => {
                        this.props.SET_PROCESS_LIST(requestData.data)
                        this.setState({ isCPRequestLoading: false });
                    }).catch(error => {
                        console.log('error is:', error)
                    }).finally(() => {
                    })
                })
            }
        });
    }

    setPagesCount(count) {
        const { itemsPerPage, pageRange, currentPage } = this.state;
        const totalPages = Math.ceil(count / itemsPerPage);
        if (parseInt(pageRange) > totalPages) {
            this.setState({
                lastIndexOfBucket: totalPages,
                firstIndexOfBucket: 0,
            });
        }
        else {
            this.setState({
                lastIndexOfBucket: currentPage + pageRange,
                firstIndexOfBucket: currentPage,
            });
        }
    }

    buildGetProcessListFilters = () => {
        const { requestId, itemsPerPage, currentPage } = this.state;
        const filters = {};
        const programsId = []
        filters.clientIds = this.props.userClients.map(c => c.clientId);
        this.props.programs.forEach(p => {
            if (p.portalType === 'b2c' || p.portalType === 'homeCustomer') {
                programsId.push(p.id)
            }
        });
        filters.programs = programsId
        if (requestId) {
            filters.requestId = requestId;
        }
        return {
            ...filters,
            itemsPerPage,
            currentPage: currentPage + 1
        };
    }

    requestIDChange = (e) => {
        const { name, value } = e.target;
        if (value === "") {
            this.requestIdsearch()
        }
        this.setState({
            [name]: value,
        })
    }
    requestIdsearch() {
        this.setState({ currentPage: 0 }, this.getProcessList)
    }

    /* on Page Change */
    handlePageClick(event, index) {
        event.preventDefault();
        this.setState({ currentPage: index }, this.getProcessList)
    }

    goToPrev = () => {
        const { pageRange, firstIndexOfBucket } = this.state;
        if ((firstIndexOfBucket - pageRange) > 0) {
            this.setState({
                firstIndexOfBucket: firstIndexOfBucket - pageRange,
                lastIndexOfBucket: firstIndexOfBucket,
                isPrevActive: true,
                isNextActive: true
            })
        } else {
            this.setState({
                firstIndexOfBucket: 0,
                lastIndexOfBucket: pageRange,
                isPrevActive: false,
                isNextActive: true
            })
        }
    }

    goToNext = () => {
        const { itemsPerPage, pageRange, firstIndexOfBucket, lastIndexOfBucket } = this.state;
        let totalCount = 0;
        if (this.state.allProcessCountList && this.state.allProcessCountList.count) {
            totalCount = this.state.allProcessCountList.count;
        }
        if (parseInt(lastIndexOfBucket + pageRange) < Math.ceil(totalCount / itemsPerPage)) {
            this.setState({
                firstIndexOfBucket: parseInt(lastIndexOfBucket),
                lastIndexOfBucket: parseInt(lastIndexOfBucket + pageRange),
                isNextActive: true,
                isPrevActive: true
            })
        } else {
            if (lastIndexOfBucket === Math.ceil(totalCount / itemsPerPage)) { }

            else {
                this.setState({
                    firstIndexOfBucket: firstIndexOfBucket + pageRange,
                    lastIndexOfBucket: Math.ceil(totalCount / itemsPerPage),
                    isNextActive: false,
                    isPrevActive: true
                })
            }
        }
    }

    onClickAction = async (item) => {
        this.setState({
            isCollectionDetails: true, selectedDispalyId: item.displayId
        })
        this.props.history.push({
            pathname : '/dashboard/LabelPage',
            state :{ reqId : item.id, compLoc : false }
        })
    }

    render() {
        const { processList } = this.props
        const { currentPage, itemsPerPage } = this.state;
        // Logic for displaying page numbers
        const pageNumbersToShow = [...Array(this.state.lastIndexOfBucket - this.state.firstIndexOfBucket).keys()]
        const renderPageNumbers = pageNumbersToShow.map(number => {
            return (
                <PaginationItem active={this.state.firstIndexOfBucket + number === currentPage} key={number}>
                    <PaginationLink key={number} id={number}
                        onClick={e => this.handlePageClick(e, parseInt(this.state.firstIndexOfBucket + number))}>
                        {parseInt(this.state.firstIndexOfBucket + number + 1)}
                    </PaginationLink>
                </PaginationItem>
            );
        });
        return (
            <Fragment>
                <CSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <PageTitle heading="Labels" subheading="Here you will see all Labels and Invoices" icon="pe-7s-ticket icon-gradient bg-ripe-malin" />
                    <Card style={{ padding: "20px" }}>
                        <div className="px-5 pt-4">
                            <Col xl={3}>
                                <Label>Request Id</Label>
                                <InputGroup>
                                    <Input type="search" aria-label="Search Request Id" name="requestId" value={this.state.requestId} onChange={this.requestIDChange} />
                                    <InputGroupAddon addonType="append" onClick={() => this.requestIdsearch()}>
                                        <InputGroupText>
                                            <FontAwesomeIcon title="Search" icon={faSearch} />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </div>
                        <div className="px-5 py-4">
                            <Col>
                                <Table bordered size="sm">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Request Id</th>
                                            <th>Request Type</th>
                                            <th>Processing Facility</th>
                                            <th>Portal Name (Client Name)</th>
                                            <th>Labels</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.isCPRequestLoading ?
                                                (<tr className="tbl_row text-center"><td className="text-center font-weight-bold text-info" style={{ fontSize: "30px" }} colSpan={6}>Loading...</td></tr>)
                                                : null
                                        }
                                        {
                                            !this.state.isCPRequestLoading && (processList && processList.length === 0) ?
                                                (<tr className="text-center"><td colSpan={6}>No Data</td></tr>)
                                                :
                                                !this.state.isCPRequestLoading && processList && processList.map((item, index) => (
                                                    <tr key={index} className="onHoverList">
                                                        <td>{itemsPerPage * currentPage + index + 1}</td>
                                                        <td className="align-middle">{item.displayId}</td>
                                                        <td className="align-middle">{item.requestTypeInfo && item.requestTypeInfo.name ? item.requestTypeInfo.name : '--'}</td>
                                                        <td className="align-middle">{item.recyclintPartnerInfo && item.recyclintPartnerInfo.name ? item.recyclintPartnerInfo.name : '--'}</td>
                                                        <td className="align-middle">{item.portalInfo && item.portalInfo.name ? item.portalInfo.name : '--'} {item.clientInfo && item.clientInfo.name ? "(" + item.clientInfo.name + ")" : null}</td>
                                                        <td className="align-middle" onClick={e => this.onClickAction(item)}><FontAwesomeIcon style={{ marginRight: '8px', cursor: 'pointer', color: '#252f3e' }} icon={faExternalLinkSquareAlt} /></td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </Table>
                                <Row>
                                    <Col xl={6}>
                                        {!this.state.isCPRequestLoading && (processList && processList.length) ? (
                                            <Pagination aria-label="Page navigation example" className="pageNav">
                                                {this.state.isPrevActive ?
                                                    <PaginationItem>
                                                        <PaginationLink previous onClick={this.goToPrev} href="#" />
                                                    </PaginationItem> :
                                                    <PaginationItem disabled>
                                                        <PaginationLink previous onClick={this.goToPrev} href="#" />
                                                    </PaginationItem>
                                                }
                                                {renderPageNumbers}
                                                {
                                                    this.state.isNextActive && (this.state.allProcessCountList && this.state.allProcessCountList.count > 10) ?
                                                        <PaginationItem >
                                                            <PaginationLink next onClick={this.goToNext} href="#" />
                                                        </PaginationItem> : <PaginationItem disabled>
                                                            <PaginationLink next onClick={this.goToNext} href="#" />
                                                        </PaginationItem>
                                                }
                                            </Pagination>
                                        ) : null}
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Card>
                </CSSTransitionGroup>
            </Fragment>
        )
    }
}
export default connect(mapStateToProps, mapActionsToProps)(WarehouseLabel);